import type { HandoffRedemption } from "./impersonation-handoff";

// sessionStorage is isolated per tab: reloading one user must never replace
// another tab's identity. Keep an ended marker so expiry fails closed on reload.
const KEY = "authe:dashboard:impersonation:v1";
export type StoredImpersonation = HandoffRedemption | { ended: true };

export function readImpersonation(storage: Storage = sessionStorage): StoredImpersonation | null {
  const raw = storage.getItem(KEY);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as HandoffRedemption;
    const expires = Date.parse(value.expiresAt ?? "");
    if (!value.tokens?.access_token || !value.tokens?.id_token || !Number.isFinite(expires) || expires <= Date.now()) {
      endImpersonation(storage);
      return { ended: true };
    }
    return value;
  } catch {
    endImpersonation(storage);
    return { ended: true };
  }
}

export function saveImpersonation(session: HandoffRedemption, storage: Storage = sessionStorage): void {
  storage.setItem(KEY, JSON.stringify(session));
}

export function endImpersonation(storage: Storage = sessionStorage): void {
  storage.setItem(KEY, JSON.stringify({ ended: true }));
}
